import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=0fbfaa6c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=0fbfaa6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbfaa6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fbfaa6c')) {
      api.createRecord('0fbfaa6c', component.options)
    } else {
      api.reload('0fbfaa6c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=0fbfaa6c&scoped=true&", function () {
      api.rerender('0fbfaa6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y614QLCoIRte/JS/comp/Voucher.vue"
export default component.exports